import showcase from '@app/lang/reverse/en/showcase';
import { COMMON_EN } from '@app/lang/reverse/en/common';
import { SEARCHING_EN } from '@app/lang/reverse/en/searching';
import { INTERVIEWING_EN } from '@app/lang/reverse/en/interviewing';
import { CLOSING_EN } from '@app/lang/reverse/en/closing';
import { SUCCESS_FEE_EN } from '@app/lang/reverse/en/success-fee';
import { HOMEPAGE_EN } from '@app/lang/reverse/en/homepage';
import { CANDIDATE_DETAILS_EN } from '@app/lang/reverse/en/candidate-details';
import { ERRORS_EN } from '@app/lang/reverse/en/errors';
import * as PROFILING_EN from '@app/lang/reverse/en/profiling.json';
import * as LOGIN_EN from '@app/lang/reverse/en/login.json';
import * as GLOBAL_COMPENSATION_EN from '@app/lang/reverse/en/global-compensation.json';

const EN = {
  translation: {
    header: {
      welcome: 'Welcome',
      share: 'Share',
      hide_compensation: 'Present with compensation hidden',
      show_compensation: 'Show compensation',
    },
    hero: {
      backToHomepage: 'All your services',
      backToHomepage_headHunter: 'All services for the client',
      prospect: {
        title: 'Success fee calculation',
      },
      steps: {
        profiling: {
          title: 'Profile',
          title_no_miro: 'Contacts',
          description: 'Start',
        },
        searching: {
          title: 'Research',
          description: 'Day 1-10',
        },
        showcase: {
          title: 'Showcase',
          description: 'Day 11',
        },
        interviewing: {
          title: 'Interviews',
          title_marketing: 'Talents',
          description: 'Day 11-20',
        },
        closing: {
          title: 'Hirings',
          description: 'End',
        },
      },
      helper: {
        profiling: {
          'to-do':
            'Hi. On these pages you <strong>can see</strong> every step of the activities we carry out for you, updated in real time.',
          'to-do_withName':
            'Hi {{ name }}. On these pages you <strong>can see</strong> every step of the activities we carry out for you, updated in real time.',
          doing: '$t(hero.helper.profiling.to-do)',
          doing_withName: '$t(hero.helper.profiling.to-do_withName)',
          done: '$t(hero.helper.profiling.to-do)',
          done_withName: '$t(hero.helper.profiling.to-do_withName)',
        },
        searching: {
          'to-do':
            'During the search, until the data is available, <strong>you will see the activities I carry out for you.</strong>',
          doing:
            'During the search, until the data is available, <strong>you will see the activities I carry out for you.</strong>',
          done: 'We have presented your company and the position to the candidates. This is <strong>what the numbers are telling us</strong>.',
        },
        interviewing: {
          'to-do':
            'At this stage <strong>I will show you the candidates and we will need to gather timely feedback</strong>.',
          doing:
            'We are in the middle of the selection process. Remember, <strong>the quicker we are, the more likely we are to recruit.</strong>',
          done: 'We are in the middle of the selection process. Remember, <strong>the quicker we are, the more likely we are to recruit.</strong>',
        },
        closing: {
          'to-do':
            'It is the final phase: the most delicate one. <strong>Negotiation, resignation and onboarding</strong>.',
          doing:
            'It is the final phase: the most delicate one. <strong>Negotiation, resignation and onboarding</strong>.',
          done: 'It is the final phase: the most delicate one. <strong>Negotiation, resignation and onboarding</strong>.',
        },
        marketing: {
          profiling: {
            'to-do':
              'Hi. On these pages you can see the <strong>talents we have selected for you</strong> and if you decide to meet them, everything about their status in the <strong>selection process</strong>.',
            'to-do_withName':
              'Hi {{ name }}. On these pages you can see the <strong>talents we have selected for you</strong> and if you decide to meet them, everything about their status in the <strong>selection process</strong>.',
            doing: '$t(hero.helper.marketing.profiling.to-do)',
            doing_withName:
              '$t(hero.helper.marketing.profiling.to-do_withName)',
            done: '$t(hero.helper.marketing.profiling.to-do)',
            done_withName: '$t(hero.helper.marketing.profiling.to-do_withName)',
          },
          interviewing: {
            'to-do':
              'As soon as talents that could be a <strong>good fit for you</strong> are identified, you will find them here.',
            doing:
              "Good candidates move quickly! Time is crucial – consider an interview. <strong>It's always worth exploring</strong>.",
            done: '$t(hero.helper.marketing.interviewing.doing)',
          },
        },
      },
    },
    profile: {
      contract: {
        title: "Here you'll find this service's contract",
        title_marketing: 'Discover top talents,<br/>pay only when you hire.',
        download: 'Download the contract',
      },
      references: {
        title: 'Your contacts',
        blank: {
          title: 'To assign to',
          subtitle: 'Head Hunter',
          text: 'To choose based on the service',
        },
      },
      mirror: {
        body: 'A new way of recruiting: flexible, digital and specialised.',
        link: 'Discover Collaborative Recruitment',
      },
    },
    general: {
      error: {
        title: 'An error has occurred.',
        subtitle:
          "Please refresh the page. If it's not resolved, try again later.",
        button: 'Go back to home',
        hash: {
          title: 'This link is no longer valid.',
          subtitle:
            'You should have received the <strong>right link in one of our emails</strong>.',
          disclaimer:
            "Can't find it? <strong>Please get in touch with your contact persons</strong>",
        },
        unauthorized: {
          title: 'Wrong link.',
          subtitle:
            'You should have received the <strong>right link</strong> in one <strong>of our emails</strong>, shortly <strong>after having signed the contract.</strong>',
          disclaimer:
            "Can't find it? <strong>Please get in touch with your contact persons</strong>",
        },
        unauthorizedHomepage: {
          title: 'You are not authorized to view this page.',
          subtitle: '',
          disclaimer: '',
        },
      },
      document_title: {
        profiling: 'Profile',
        searching: 'Research',
        interviewing: 'Interviews',
        closing: 'Closing',
        showcase: 'Showcase',
      },
      document_title_reverse_marketing: {
        profiling: '$t(hero.steps.profiling.title_no_miro)',
        searching: '$t(hero.steps.searching.title)',
        interviewing: '$t(hero.steps.interviewing.title_marketing)',
        closing: '$t(hero.steps.closing.title)',
        showcase: '$t(hero.steps.showcase.title)',
      },
      date_on: 'on',
      date_hour: 'at',
    },
    candidate: {
      hero: {
        title: 'you are looking for:',
        back_label: 'Back',
      },
      infos: {
        age: 'years',
        benefits: 'Current benefits',
        bonuses: 'Current bonus',
      },
      sections: {
        horse: {
          title: 'Current status',
        },
        bet: {
          open_chat: 'Chat with <strong>{{ name }}</strong>',
        },
        curriculum: {
          title: 'CV',
          screening: 'Screening ranking',
          button: 'Download the CV',
        },
        summary: {
          otherSelectionsTitle: 'Other selection processes',
        },
        concerns: {
          intro:
            '{{ name }} is a really interesting profile, but they do not completely fulfill the requirements.',
        },
      },
    },
    footer: {
      company: '© Reverse SpA',
      headquarter: 'Registered Office: Piazza Sigmund Freud 1, 20154 Milano',
      informations: [
        'VAT Number: 09714690964',
        'PEC: reversespa@pec.it',
        'Commercial registry: MI - 2109818',
        'Paid up share capital: 50.000€',
      ],
      menu: {
        contact: {
          label: 'Contact us',
          slug: 'contact-us',
        },
        legal: {
          label: 'Legal',
          slug: 'legal',
        },
        cookies: {
          label: 'Cookies',
          url: 'https://www.iubenda.com/privacy-policy/19612468/cookie-policy',
        },
      },
    },
    modal: {
      share: {
        title: 'Share recruitment progress with others',
        inputs: {
          first_name: {
            label: 'Name',
            placeholder: 'Name',
          },
          last_name: {
            label: 'Surname',
            placeholder: 'Surname',
          },
          email: {
            label: 'Email',
            placeholder: 'Email',
            hint: 'This e-mail adress does not have the same domain you signed up with. Do you want to proceed anyway?',
          },
          lang: {
            label: 'Language',
            placeholder: 'Select language',
          },
        },
        isCompensationPackageVisible: {
          label:
            'Allow the invited person to <strong>view candidate compensation packages</strong>.',
        },
        lang_options: {
          it: 'Italian',
          en: 'English',
          de: 'German',
          fr: 'French',
          es: 'Spanish',
        },
        button: 'Invite',
        shared_with: 'Shared with',
        alert: {
          positive: 'Email invitation has been sent',
          negative:
            'Something went wrong. Please try again later or contact us.',
          guest_info:
            "The invited person won't be able to see candidate compensation packages. If they need access to this information, ask {{ mainClient }} or the headhunter to enable the permissions.",
        },
        table: {
          header: {
            name: 'Name',
            email: 'Email',
            compensationVisibility: 'Compensation visibility',
          },
          guest: '(Guest)',
          mainClient: '(Main client)',
        },
      },
    },
    validation: {
      scout_approved: 'Validated by Scout',
      scout_required: 'Requires Scout validation',
      required: 'This field is required',
      email: 'This email address is not valid',
    },
    language_switcher: {
      it: 'IT',
      en: 'EN',
      de: 'DE',
      fr: 'FR',
      es: 'ES',
    },
    showcase,
    candidateDetails: CANDIDATE_DETAILS_EN,
    common: COMMON_EN,
    searching: SEARCHING_EN,
    interviewing: INTERVIEWING_EN,
    closing: CLOSING_EN,
    successFee: SUCCESS_FEE_EN,
    globalCompensation: GLOBAL_COMPENSATION_EN,
    homepage: HOMEPAGE_EN,
    login: LOGIN_EN,
    profiling: PROFILING_EN,
    errors: ERRORS_EN,
  },
};

export default EN;
